/* eslint-disable vue/valid-v-for */
<template>
  <div class="detail-container">
    <div class="title-box">
      <div class="name">基础信息</div>
      <div class="border"></div>
    </div>
    <ul class="form">
      <li class="form-item">
        <span class="key">站点类型</span>
        <span class="value"> {{ detail.spiderClassType }}</span>
      </li>
      <li class="form-item">
        <span class="key">国家</span>
        <span class="value">{{ detail.countryName }}</span>
      </li>
      <li class="form-item">
        <span class="key">语言</span>
        <span class="value">{{ detail.langName }}</span>
      </li>
      <li class="form-item">
        <span class="key">用户ID</span>
        <span class="value">{{ detail.accountId }}</span>
      </li>

      <li class="form-item">
        <span class="key">用户名称</span>
        <span class="value">{{ detail.spiderName }}</span>
      </li>
      <li class="form-item">
        <span class="key">调度周期时间</span>
        <span class="value">{{ detail.spiderExecTimeCycle }}</span>
      </li>
      <li class="form-item" v-if="detail.accountDesc">
        <span class="key">账号描述</span>
        <span class="value">{{ detail.accountDesc }}</span>
      </li>
      <li class="form-item" v-if="detail.ipConfigCountryName">
        <span class="key">代理国家</span>
        <span class="value">{{ detail.ipConfigCountryName }}</span>
      </li>
      <li class="form-item" v-if="detail.ipConfigNum">
        <span class="key" >代理数量</span>
        <span class="value">{{ detail.ipConfigNum }}</span>
      </li>
      <li class="form-item" v-if="detail.ipConfigNum">
        <span class="key" >代理数量</span>
        <span class="value">{{ detail.ipConfigNum }}</span>
      </li>
      <li class="form-item" v-if="detail.spiderUrls && detail.spiderUrls.length">
        <span class="key">关键词</span>
        <ul class="value" style="display: flex;flex-wrap: wrap;">
          <li class="keys" v-for="(item, index) in detail.spiderUrls" :key="index">
            {{ item }}
          </li>
        </ul>
      </li>
      <li class="form-item" v-if="detail.spiderTags && detail.spiderTags.length">
        <span class="key">标签设置</span>
        <span class="value">
          <a-tag size="large" v-for="(item, index) in detail.spiderTags" :key="index">
            {{ item.spiderTagName }}
          </a-tag>
        </span>
      </li>
    </ul>
  </div>
</template>

<script>
import { getSpiderTwitterByIdApi, getSpiderApiByIdApi } from '@/api/Site/Create'

export default {
  name: 'Config',
  data() {
    return {
      detail: {}
    }
  },
  created() {
    this.getSingleDetail()
  },
  methods: {
    async getSingleDetail() {
      if (this.$route.query.type === 'toutiao') {
        const { code, extra } = await getSpiderApiByIdApi(this.$route.query)
        if (code === 200) {
          this.detail = extra.data
        }
      } else {
        const { code, extra } = await getSpiderTwitterByIdApi(this.$route.query)
        if (code === 200) {
          this.detail = extra.spiderTwitter
        }
      }
    }
  }
}
</script>

<style scoped lang="less">
.detail-container {
  background: #fff;
  padding: 20px;

  .title-box {
    display: flex;
    margin-bottom: 30px;
    font-weight: bold;
    .name {
      border-left: 2px solid #1890ff;
      padding: 0 8px;
      height: 14px;
      line-height: 14px;
    }
    .border {
      border-bottom: 1px solid #ebebeb;
      flex: 1;
      position: relative;
      top: -6px;
    }
  }

  .form {
    display: grid;
    grid-template-columns: repeat(3, 33.33%);
    grid-row-gap: 20px;
    margin-bottom: 40px;
    .form-item {
      display: flex;
    }
    .key {
      color: #bbbbbb;
      margin-right: 10px;
      display: inline-block;
      width: 110px;
      text-align: right;
    }
    .value {
      color: #6d707e;
      flex: 1;
    }
  }
  .keys{
    height: 32px;
    background: #FAFAFA;
    border-radius: 2px;
    text-align: center;
    padding: 0 10px;
    line-height: 32px;
    margin: 0 10px 10px 0;
  }
}
</style>
